<template>
  <div>
    <el-button
      v-if="this.activeName == '1'"
      class="button"
      type="primary"
      @click="add()"
      >新增</el-button
    >
    <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
      <el-tab-pane label="分类管理" name="1">
        <!-- 标题 -->
        <div class="title">
          <div>方剂分类管理</div>
          <div>
            <el-button
              type="primary"
              style="margin-top: 20px;"
              @click="editSort()"
              >排序管理</el-button
            >
            <el-button
              v-show="isSortShow"
              type="primary"
              style="margin-top: 20px;"
              @click="saveSortData()"
              >保存排序</el-button
            >
          </div>
        </div>
        <el-table
          :data="classMeridiansData"
          class="table"
          style="width: 100%; margin-bottom: 20px"
          v-loading="loading"
          v-show="isSortShow"
          ref="multipleTable"
          row-key="id"
          border
        >
          <el-table-column prop="name" align="center" label="名称" width="150">
          </el-table-column>
          <el-table-column prop="id" align="center" label="ID" width="100">
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.p_id == 1"
                type="text"
                icon="el-icon-edit"
                @click="handleSon(scope.row)"
                >添加子分类</el-button
              >
              <el-button
                v-if="scope.row.p_id == 1"
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 1)"
                >编辑</el-button
              >
              <el-button
                v-else
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 2)"
                >编辑</el-button
              >
              <el-button
                v-if="scope.row.p_id == 1"
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 1)"
                >删除</el-button
              >
              <el-button
                v-else
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 2)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-table
          :data="classMeridiansData"
          v-show="!isSortShow"
          style="width: 100%; margin-bottom: 20px"
          v-loading="loading"
          row-key="id"
          :tree-props="{ children: 'sub_items' }"
          border
        >
          <el-table-column prop="name" align="center" label="名称" width="150">
          </el-table-column>
          <el-table-column prop="id" align="center" label="ID" width="100">
          </el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.p_id == 1"
                type="text"
                icon="el-icon-edit"
                @click="handleSon(scope.row)"
                >添加子分类</el-button
              >
              <el-button
                v-if="scope.row.p_id == 1"
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 1)"
                >编辑</el-button
              >
              <el-button
                v-else
                type="text"
                icon="el-icon-edit"
                @click="edit(scope.row, 2)"
                >编辑</el-button
              >
              <el-button
                v-if="scope.row.p_id == 1"
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 1)"
                >删除</el-button
              >
              <el-button
                v-else
                type="text"
                icon="el-icon-delete"
                @click="del(scope.row, 2)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-tab-pane>
      <el-tab-pane label="方剂管理" name="2">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <div class="search-left-top">
            <el-form-item label="方名：">
              <el-input v-model="formInline.title"></el-input>
            </el-form-item>
            <el-form-item label="六经：">
              <el-cascader
                :props="categoryProps"
                @change="changeCategories"
                v-model="categoryData"
                :options="options"
                ref="cascader"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="名医：">
              <el-cascader
                :props="categoryProps1"
                @change="changeCategories1"
                v-model="categoryData1"
                :options="options1"
                ref="cascader1"
              ></el-cascader>
            </el-form-item>
            <el-form-item label="功效：">
              <el-cascader
                :props="categoryProps2"
                @change="changeCategories2"
                v-model="categoryData2"
                :options="options2"
                ref="cascader2"
              ></el-cascader>
            </el-form-item>
          </div>
        </el-form>
        <!-- 标题 -->
        <div class="title">
          <div>方剂列表</div>
          <el-button type="primary" @click="search()">查询</el-button>
        </div>
        <el-table :data="fangjiData" style="width: 100%" v-loading="loading">
          <el-table-column prop="id" label="ID" align="center" width="100">
          </el-table-column>
          <el-table-column prop="title" label="方名" align="center" width="150">
          </el-table-column>
          <el-table-column prop="provenance" label="出处" align="center">
          </el-table-column>
          <el-table-column prop="price" label="定价" align="center" width="150">
            <template slot-scope="scope">
              <span v-if="scope.row.is_default_price == 1"
                >{{ scope.row.price }} 元（默认）</span
              >
              <span v-if="scope.row.is_default_price == 0"
                >{{ scope.row.price }} 元（自定义）</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="discount_type"
            label="收费类型"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <span>{{ getSflx(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="detail(scope.row)">详情</el-button>
              <el-button type="text" @click="edit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="yian_totalPages > 1">
          <el-pagination
            background
            layout="prev, pager, next"
            :current-page="yian_currentPage"
            :page-size="yian_page_size"
            :total="yian_pageTotal"
            @current-change="handlePageChange"
          ></el-pagination>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 父编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="120px">
        <el-form-item label="分类名称：" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="saveEdit()">提 交</el-button>

        <el-button type="primary" @click="editVisible = false">取 消</el-button>
      </span>
    </el-dialog>

    <!-- 子编辑弹出框 -->
    <el-dialog
      :visible.sync="editVisible1"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form1" label-width="120px">
        <el-form-item label="分类名称：" prop="name">
          <el-input v-model="form1.name"></el-input>
        </el-form-item>

        <el-form-item label="父级分类：" prop="father_class">
          <el-select v-model="form1.father_class" class="handle-select mr10">
            <el-option
              v-for="(child, index) in father_class"
              :key="index"
              :label="child.name"
              :value="child.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer self-dialog-footer">
        <el-button type="primary" @click="submit()">提 交</el-button>

        <el-button type="primary" @click="editVisible1 = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
    <!-- 方剂管理编辑弹出框 -->
    <el-dialog
      :visible.sync="editFangjiVisible"
      width="50%"
      :close-on-click-modal="false"
      v-if="this.activeName == '2'"
    >
      <el-form ref="ruleForm" :model="fangjiForm" label-width="180px">
        <el-form-item label="方剂ID：">
          <el-input disabled type="text" v-model="fangjiForm.id"></el-input>
        </el-form-item>
        <el-form-item label="方剂名：">
          <el-input type="text" v-model="fangjiForm.title"></el-input>
        </el-form-item>
        <el-form-item label="主治：">
          <el-input type="text" v-model="fangjiForm.indications"></el-input>
        </el-form-item>
        <el-form-item label="方剂首字母：">
          <el-input type="text" v-model="fangjiForm.title_initial"></el-input>
        </el-form-item>
        <el-form-item label="禁忌：">
          <el-input type="text" v-model="fangjiForm.taboo"></el-input>
        </el-form-item>
        <el-form-item label="方解：">
          <el-input type="text" v-model="fangjiForm.explanation"></el-input>
        </el-form-item>
        <el-form-item label="出处：">
          <el-input type="text" v-model="fangjiForm.provenance"></el-input>
        </el-form-item>
        <el-form-item label="组成：">
          <el-input type="text" v-model="fangjiForm.composition"></el-input>
        </el-form-item>
        <el-form-item label="功效：">
          <el-input type="text" v-model="fangjiForm.effect"></el-input>
        </el-form-item>
        <el-form-item label="加减：">
          <el-input type="text" v-model="fangjiForm.adjustment"></el-input>
        </el-form-item>
        <el-form-item label="治验：">
          <el-input type="text" v-model="fangjiForm.cases"></el-input>
        </el-form-item>
        <el-form-item label="方剂代码：">
          <el-input type="text" v-model="fangjiForm.sequence_number"></el-input>
        </el-form-item>
        <el-form-item label="方剂名称全拼：">
          <el-input type="text" v-model="fangjiForm.title_spell"></el-input>
        </el-form-item>
        <el-form-item label="分类名称：">
          <el-input type="text" v-model="fangjiForm.cate_name"></el-input>
        </el-form-item>
        <el-form-item label="定价：">
          <div style="display: flex">
            <el-select
              v-model="f_price"
              class="handle-select"
              @change="selectChange(4, $event)"
            >
              <el-option
                v-for="(child, index) in priceList"
                :key="index"
                :label="child.label"
                :value="child.value"
              ></el-option>
            </el-select>
            <span
              v-if="f_price == 0"
              style="display: flex; justify-content: center; margin-left: 50px"
            >
              <el-input
                v-model="fangjiForm.price"
                type="text"
                style="margin-right: 10px"
              ></el-input
              >元
            </span>
          </div>
        </el-form-item>
        <div style="display: flex; flex-direction: column; align-items: center">
          <div style="width: 100%; display: flex; align-items: center">
            <el-form-item label="免费状态：" style="margin-bottom: 10px">
              <el-select
                v-model="f_discount_type"
                class="handle-select"
                @change="selectChange(5, $event)"
              >
                <el-option
                  v-for="child in free_status"
                  :key="child.value"
                  :label="child.label"
                  :value="child.value"
                ></el-option>
              </el-select>
            </el-form-item>

            <span
              v-if="f_discount_type == 3 || f_discount_type == 4"
              style="display: flex; align-items: center; margin-left: 50px"
            >
              <el-input
                v-model="fangjiForm.discount.discount"
                type="text"
                style="margin-right: 10px"
              ></el-input
              >折
            </span>
          </div>

          <el-date-picker
            v-if="f_discount_type == 2 || f_discount_type == 4"
            class="handle-date mr10"
            style="margin: 20px 140px 0px 0px"
            v-model="fangjiForm.date"
            type="datetimerange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd hh:mm:ss"
            @change="dateChange()"
          >
            >
          </el-date-picker>
        </div>
        <el-form-item label="标签：">
          <div
            v-for="(item, i) in fangjiForm.labels"
            :key="i"
            style="margin-bottom: 10px;display: flex;align-items: center;"
          >
            <el-select v-model="item.type" class="handle-select">
              <el-option
                v-for="(child, index) in bqList"
                :key="index"
                :label="child.label"
                :value="child.value"
              ></el-option>
            </el-select>
            <el-input
              type="text"
              v-model="item.title"
              style="width:200px;margin-left: 10px;margin-right: 10px;"
            ></el-input>
            <el-button type="primary" @click="delBq(i)">删 除</el-button>
          </div>
          <el-button type="primary" @click="addBq">添 加</el-button>
        </el-form-item>
      </el-form>
      <span
        v-if="is_add == false"
        slot="footer"
        class="dialog-footer self-dialog-footer"
      >
        <el-button type="primary" @click="saveEdit()">提 交</el-button>

        <el-button type="primary" @click="editFangjiVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/zkApiConfig";
import http2 from "../../../api/uploadApiConfig";
import Sortable from "sortablejs";
import md5 from "js-md5";
export default {
  data() {
    return {
      id: "",
      imageUrl: "",
      uploading: false,
      editVisible: false,
      editVisible1: false,
      editMeridiansVisible: false,
      editFangjiVisible: false,
      editHotVisible: false,
      classificationDataLv2Visible: false,
      is_add: true,
      parent_id: "",
      class_id: "",
      p_id: "",
      classification_type: 1,
      fangji_id: "",
      activeName: "1",
      loading: false,
      father_class: [],
      //   类别
      categoryData: [],
      categoryData1: [],
      categoryData2: [],
      options: [],
      options1: [],
      options2: [],
      categoryProps: {
        label: "name", // 字段必须统一
        value: "id", // 字段必须统一
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          http
            .get("/admin/zk_fang/lj", {
              params: { p_id: node.data.id },
            })
            .then((res) => {
              setTimeout(() => {
                console.log(res);
                const nodes = res.data.data.map((item) => ({
                  id: item.id,
                  name: item.name,
                  leaf: level >= 1,
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
                console.log(nodes, "nodes");
              }, 1000);
            });
        },
      },
      categoryProps1: {
        label: "name", // 字段必须统一
        value: "id", // 字段必须统一
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          http
            .get("/admin/zk_fang/famous", {
              params: { p_id: node.data.id },
            })
            .then((res) => {
              setTimeout(() => {
                console.log(res);
                const nodes = res.data.data.map((item) => ({
                  id: item.id,
                  name: item.name,
                  leaf: level >= 1,
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }, 1000);
            });
        },
      },
      categoryProps2: {
        label: "name", // 字段必须统一
        value: "id", // 字段必须统一
        lazy: true,
        lazyLoad(node, resolve) {
          const { level } = node;
          http
            .get("/admin/zk_fang/category_select", {
              params: { p_id: node.data.id },
            })
            .then((res) => {
              setTimeout(() => {
                const nodes = res.data.data.map((item) => ({
                  id: item.id,
                  name: item.name,
                  leaf: level >= 2,
                }));
                // 通过调用resolve将子节点数据返回，通知组件数据加载完成
                resolve(nodes);
              }, 1000);
            });
        },
      },
      father_add: true,
      // ----------------搜索----------------
      formInline: {},
      //   一级分类
      classMeridiansData: [],
      //   医案列表
      fangjiData: [],
      //   医案管理分页
      yian_currentPage: 1,
      yian_totalPages: 1,
      yian_page_size: 10,
      yian_pageTotal: 10,
      yian_page_index: 10,
      classForm: {},
      form: {},
      form1: {},
      fangjiForm: {},
      // 标签
      labels: "",
      bqList: [
        {
          value: "1",
          label: "书名",
        },
        {
          value: "2",
          label: "书目",
        },
        {
          value: "3",
          label: "作者",
        },
        {
          value: "4",
          label: "科室",
        },
        {
          value: "5",
          label: "医生",
        },
        {
          value: "6",
          label: "出处",
        },
        {
          value: "7",
          label: "疾病",
        },
        {
          value: "9",
          label: "功效",
        },
        {
          value: "10",
          label: "经络",
        },
        {
          value: "11",
          label: "朝代",
        },
        {
          value: "12",
          label: "方剂名",
        },
        {
          value: "13",
          label: "中药名称",
        },
        {
          value: "14",
          label: "经穴名称",
        },
      ],
      //   定价
      priceList: [
        {
          value: 0,
          label: "自定义",
        },
        {
          value: 1,
          label: "默认公式",
        },
      ],
      f_price: 0,
      //   免费状态
      f_discount_type: 1,
      free_status: [
        {
          value: 0,
          label: "无优惠",
        },
        {
          value: 1,
          label: "免费",
        },
        {
          value: 2,
          label: "限时免费",
        },
        {
          value: 3,
          label: "折扣",
        },
        {
          value: 4,
          label: "限时折扣",
        },
      ],
      isSortShow: false,
      dataArr: [],
      ids: [],
      sort_id: 1,
    };
  },
  mounted() {
    this.getDefault();
  },
  methods: {
    // 排序管理
    editSort() {
      this.isSortShow = !this.isSortShow;
    },
    // 保存排序
    saveSortData() {
      this.ids = [];
      for (let i = 0; i < this.dataArr.length; i++) {
        this.ids.push(this.dataArr[i].id);
      }
      let params = {
        ids: this.ids.toString(),
      };
      http.put("/admin/zk_fang/sort/categories", params).then((res) => {
        if (res.data.status_code == 200) {
          this.$message.success("保存成功");
          this.isSortShow = false;
          this.getDefault();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 拖拽
    initSortTable() {
      // 获取 el-table
      const tableTag = this.$refs["multipleTable"].$el;
      // 获取 tbody 节点
      const elTbody = tableTag.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[0];
      // 拖拽排序
      this.sortable = Sortable.create(elTbody, {
        onEnd: (evt) => {
          const tempIndex = this.dataArr.splice(evt.oldIndex, 1)[0];
          this.dataArr.splice(evt.newIndex, 0, tempIndex);
        },
      });
    },
    addBq() {
      var newItem = { bq_name: "", leiMu: "" };
      this.fangjiForm.labels.push(newItem);
    },
    delBq(i) {
      this.fangjiForm.labels.splice(i, 1);
    },
    // 时间
    dateChange() {
      console.log(this.fangjiForm.date, "e");
      this.fangjiForm.discount.begin_time = this.fangjiForm.date[0];
      this.fangjiForm.discount.end_time = this.fangjiForm.date[1];
    },
    selectChange(type, e) {
      if (type == 4) {
        this.fangjiForm.price_type == e;
        if (this.fangjiForm.price_type == 1) {
          this.fangjiForm.price = 5;
        }
      } else if (type == 5) {
        this.fangjiForm.discount_type == e;
      }
    },
    getSflx(row) {
      if (row.discount_type == 0) {
        return "无优惠";
      } else if (row.discount_type == 1) {
        return "免费";
      } else if (row.discount_type == 2) {
        return (
          row.discount.begin_time + "~" + row.discount.end_time + "\n限时免费"
        );
      } else if (row.discount_type == 3) {
        return "折扣";
      } else if (row.discount_type == 4) {
        return (
          row.discount.begin_time + "~" + row.discount.end_time + "\n限时折扣"
        );
      }
    },

    getDefault() {
      if (this.activeName == 1) {
        this.loading = true;
        http.get("/admin/zk_fang/categories").then((res) => {
          if (res.data.status_code == 200) {
            this.classMeridiansData = res.data.data;
            this.father_class = res.data.data;
            this.dataArr = res.data.data;
            this.$nextTick(() => {
              this.initSortTable();
            });
            this.loading = false;
          }
        });
      } else if (this.activeName == 2) {
        // 六经分类
        let p_id = 0;
        http
          .get("/admin/zk_fang/lj", {
            params: { p_id: p_id },
          })
          .then((res) => {
            if (res.data.status_code == 200) {
              this.options = res.data.data;
            }
          });
        let p_id1 = 0;
        http
          .get("/admin/zk_fang/famous", {
            params: { p_id: p_id1 },
          })
          .then((res) => {
            if (res.data.status_code == 200) {
              this.options1 = res.data.data;
            }
          });
        let p_id2 = 1;
        http
          .get("/admin/zk_fang/category_select", {
            params: { p_id: p_id2 },
          })
          .then((res) => {
            if (res.data.status_code == 200) {
              this.options2 = res.data.data;
            }
          });
        this.loading = true;
        let params = {
          page: this.yian_currentPage,
          yian_page_size: this.yian_page_size,
          title: this.formInline.title,
          lj_name: this.formInline.lj_name,
          prescription_name: this.formInline.prescription_name,
          famous_name: this.formInline.famous_name,
        };
        http.get("/admin/zk_fang/fangs", { params: params }).then((res) => {
          if (res.data.status_code == 200) {
            this.formInline.lj_name = "";
            this.formInline.prescription_name = "";
            this.formInline.famous_name = "";
            this.fangjiData = res.data.data.data;
            this.yian_currentPage = Number(res.data.data.current_page);
            this.yian_totalPages = res.data.data.last_page;
            this.yian_pageTotal = this.yian_totalPages * this.yian_page_size;
            this.loading = false;
          }
        });
      }
    },
    changeCategories() {
      this.formInline.lj_name = this.$refs[
        "cascader"
      ].getCheckedNodes()[0].label;
    },
    changeCategories1() {
      this.formInline.prescription_name = this.$refs[
        "cascader1"
      ].getCheckedNodes()[0].label;
    },
    changeCategories2() {
      this.formInline.famous_name = this.$refs[
        "cascader2"
      ].getCheckedNodes()[0].label;
    },
    // 搜索
    search() {
      if (this.activeName == 2) {
        this.getDefault();
      }
    },
    // 新增
    add() {
      if (this.activeName == "1") {
        this.father_add = true;
        this.form = {};
        this.editVisible = true;
      } else if (this.activeName == "2") {
        this.fangjiForm = {};
        this.editFangjiVisible = true;
        this.is_edit = false;
        this.is_add = false;
      }
    },
    // 提交
    saveEdit() {
      if (this.activeName == "1") {
        if (this.father_add == true) {
          let params = {
            name: this.form.name,
            p_id: 1,
          };
          http.post("/admin/zk_fang/category", params).then((res) => {
            if (res.data.status_code == 200) {
              this.getDefault();
              this.editVisible = false;
              this.$message.success("新增成功");
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else if (this.father_add == false) {
          let params = {
            name: this.form.name,
            p_id: 1,
          };
          http.put("/admin/zk_fang/category/" + this.id, params).then((res) => {
            if (res.data.status_code == 200) {
              this.getDefault();
              this.editVisible = false;
              this.$message.success("修改成功");
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      } else if (this.activeName == "2") {
        if (this.is_edit == true) {
          // 标签处理
          let labels = this.fangjiForm.labels;
          let data = "";
          var data1 = "";
          for (let i = 0; i < labels.length; i++) {
            data = labels[i].type + "_" + labels[i].title + ",";
            data1 += data;
          }
          data1 = data1.substring(0, data1.length - 1);
          let params = {
            discount_type: this.discount_type,
            price: this.fangjiForm.price,
            indications: this.fangjiForm.indications,
            title: this.fangjiForm.title,
            title_initial: this.fangjiForm.title_initial,
            title_spell: this.fangjiForm.title_spell,
            taboo: this.fangjiForm.taboo,
            explanation: this.fangjiForm.explanation,
            provenance: this.fangjiForm.provenance,
            composition: this.fangjiForm.composition,
            effect: this.fangjiForm.effect,
            adjustment: this.fangjiForm.adjustment,
            cases: this.fangjiForm.cases,
            sequence_number: this.fangjiForm.sequence_number,
            labels: data1,
            start_time:
              this.f_discount_type == 2 || this.f_discount_type == 4
                ? this.yianForm.discount.begin_time
                : "",
            end_time:
              this.f_discount_type == 2 || this.f_discount_type == 4
                ? this.yianForm.discount.end_time
                : "",
            discount:
              this.f_discount_type == 2 || this.f_discount_type == 4
                ? this.yianForm.discount.discount
                : "",
          };
          http
            .put("/admin/zk_fang/fang/" + this.fangji_id, params)
            .then((res) => {
              if (res.data.status_code == 200) {
                this.$message.success("修改成功");
                this.getDefault();
                this.editFangjiVisible = false;
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      }
    },
    // 子分类
    submit() {
      if (this.is_add == true) {
        let params = {
          name: this.form1.name,
          p_id: this.form1.father_class,
        };
        http.post("/admin/zk_fang/category", params).then((res) => {
          if (res.data.status_code == 200) {
            this.getDefault();
            this.editVisible1 = false;
            this.$message.success("新增子分类成功");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else if (this.is_add == false) {
        let params = {
          name: this.form1.name,
          p_id: this.form1.father_class,
        };
        http.put("/admin/zk_fang/category/" + this.id, params).then((res) => {
          if (res.data.status_code == 200) {
            this.getDefault();
            this.editVisible1 = false;
            this.$message.success("修改子分类成功");
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    // 添加子分类
    handleSon(row) {
      this.form1 = {};
      this.is_add = true;
      this.editVisible1 = true;
      this.form1.father_class = row.id;
    },
    // 图片上传
    beforeAvatarUpload(file) {
      console.log(file, "file");
      let that = this;
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (isJPG && isLt2M) {
        var ossData = new FormData();
        let imgType = file.type.split("/")[1];
        let fileNames = file.name.split("/")[0];
        var time = new Date().getTime();
        var filename = md5(time + fileNames) + "." + imgType;
        ossData.append("work_path", "mediawiki/acupuncture");
        ossData.append("bucket", "family-tcm");
        ossData.append("end_point", "oss-cn-hangzhou.aliyuncs.com");
        ossData.append("rewrite", "1");
        ossData.append("file_name", filename);
        ossData.append("file", file);
        that.uploading = true;
        http2.post("upload", ossData).then(function(res) {
          if (res.data.status_code == 200) {
            that.imageUrl = "mediawiki/acupuncture/" + filename;
            that.fangjiForm.img_path = URL.createObjectURL(file);
          }
          that.uploading = false;
        });
      } else if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      } else if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },
    // 详情
    detail(row) {
      this.is_add = true;
      this.editFangjiVisible = true;
      this.fangji_id = row.id;
      this.getDetailInfo();
    },
    getDetailInfo() {
      let params = {
        title: this.classForm.title,
      };
      http.get("/admin/zk_fang/fang/" + this.fangji_id, params).then((res) => {
        if (res.data.status_code == 200) {
          this.fangjiForm = res.data.data;
          this.f_discount_type = this.fangjiForm.discount_type;
          let data = res.data.data;
          // 免费状态
          if (data.discount_type == 0) {
            this.fangjiForm.discount_type = "无优惠";
          } else if (data.discount_type == 1) {
            this.fangjiForm.discount_type = "免费";
          } else if (data.discount_type == 2) {
            this.fangjiForm.discount_type = "限时免费";
            this.$set(this.fangjiForm, "date", [
              data.discount.begin_time,
              data.discount.end_time,
            ]);
          } else {
            this.fangjiForm.discount_type = "限时折扣";
            this.$set(this.fangjiForm, "date", [
              data.discount.begin_time,
              data.discount.end_time,
            ]);
          }
          // 定价
          if (data.is_default_price == 0) {
            this.f_price = 0;
          } else {
            this.f_price = 1;
          }
        }
      });
    },
    // 编辑
    edit(row, type) {
      if (this.activeName == "1") {
        if (type == 1) {
          console.log(row, "row1");
          this.form = {
            name: row.name,
            father_class: row.id,
          };
          this.id = row.id;
          this.father_add = false;
          this.editVisible = true;
        } else if (type == 2) {
          console.log(row, "row2");
          this.form1 = {
            name: row.name,
            father_class: row.p_id,
          };
          this.id = row.id;
          this.is_add = false;
          this.editVisible1 = true;
        }
      } else if (this.activeName == "2") {
        this.editFangjiVisible = true;
        this.is_add = false;
        this.is_edit = true;
        this.fangji_id = row.id;
        this.getDetailInfo();
      }
    },
    // 删除
    del(row) {
      let that = this;
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("/admin/zk_fang/category/" + row.id).then((res) => {
            if (res.data.status_code == 200) {
              that.getDefault();
              that.$message.success("已删除");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 选项卡
    handleClick(tab) {
      if (tab.index == 1) {
        this.getDefault();
      }
    },
    // 医案管理分页
    handlePageChange(val) {
      this.yian_currentPage = val;
      this.getDefault();
    },
    // 时间
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.button {
  height: 40px;
  position: absolute;
  right: 28px;
  z-index: 999;
}
.title {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-td-thumb {
  display: block;
  margin: auto;
  width: 180px;
  height: 180px;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
/deep/#tab-1-1 {
  width: 200px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
